<template>
<section class="ctn">
    <header class="header left">
      <router-link class="paper-action" :to="{ path: `/servers`}"><heim-icon icon="arrow-back"></heim-icon><span>{{ $t('back') }}</span></router-link>
      <router-link class="paper-action" :to="{ path: `/servers/${server.id}/edit`}"><span>{{ $t('edit') }}</span><heim-icon icon="chevron-right"></heim-icon></router-link>
    </header>
    <main class="server-details">
      <section class="info">
        <heim-card>
          <main>
            <div class="row">
              <h1>{{ server.name }}</h1>
              <span>{{ server.ip }}</span>
            </div>
          </main>
        </heim-card>
        <heim-card class="monitoring">
          <header><h1>{{ $t('monitoring') }}</h1></header>
          <main>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('beforeNotification') }}</span>
                <span class="badge">{{ server.nb_occurence ? server.nb_occurence + " " + $t('occurences') : $t('na') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="details-row" :class="!server.cpu_alert ? 'disabled':''">
                <span>{{ $t('cpuThreshold') }}</span>
                <span class="badge">{{ server.cpu_threshold ? server.cpu_threshold + " %" : $t('na') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="details-row" :class="!server.mem_alert ? 'disabled':''">
                <span>{{ $t('memoryThreshold') }}</span>
                <span class="badge">{{ server.mem_threshold ? server.mem_threshold + " %" : $t('na')}}</span>
              </div>
            </div>
            <div class="row">
              <div class="details-row" :class="!server.drive_alert ? 'disabled':''">
                <span>{{ $t('diskThreshold') }}</span>
                <span class="badge">{{ server.drive_threshold ? server.drive_threshold + " %" : $t('na') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('pingInterval') }}</span>
                <span class="badge">{{ server.interval ? server.interval/1000 + " " + $t('seconds') : $t('na') }}</span>
              </div>
            </div>
            <header><h1>Pricing</h1></header>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('costServer') }} {{ $t('monthly') }}</span>
                <span class="badge">{{ server.cost_server ?  $n(server.cost_server, 'currency') : $t('na') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('costHardDisk') }} {{ $t('monthly') }}</span>
                <span class="badge">{{ server.cost_hard_disk ? $n(server.cost_hard_disk, 'currency') : $t('na') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('auxiliaryCost') }} {{ $t('monthly') }}</span>
                <span class="badge">{{ server.auxiliary_cost ? $n(server.auxiliary_cost, 'currency') : $t('na') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('rds') }} {{ $t('monthly') }}</span>
                <span class="badge">{{ server.rds ? $n(server.rds, 'currency') : $t('na') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('backup') }} {{ $t('monthly') }}</span>
                <span class="badge">{{ server.backup ? $n(server.backup, 'currency') : $t('na') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('bandwidth') }} {{ $t('monthly') }}</span>
                <span class="badge">{{ server.bandwidth ? $n(server.bandwidth, 'currency') : $t('na') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('ipElastic') }} {{ $t('monthly') }}</span>
                <span class="badge">{{ server.ip_elastic ? server.ip_elastic : $t('na') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('support') }} {{ $t('monthly') }}</span>
                <span class="badge">{{ server.support ? $n(server.support, 'currency') : $t('na') }}</span>
              </div>
            </div>            
            <header><h1>{{ $t('hosting') }}</h1></header>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('reservedInstance') }}</span>
                <span class="badge">{{ server.hosting_reserved != true ? $t('no') : $t('yes') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('birthday') }}</span>
                <span class="badge" v-if="server.hosting_birthday">{{ $d(new Date(server.hosting_birthday), 'short') }}</span>
                <span class="badge" v-else>n/a</span>
              </div>
            </div>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('localization') }}</span>
                <span class="badge">{{ server.hosting_localization ? server.hosting_localization : $t('na') }}</span>
              </div>
            </div>
            <header><h1>{{ $t('description') }}</h1></header>
            <div class="row">
              <p>{{ server.description ? server.description : $t('na') }}</p>
            </div>
          </main>
        </heim-card>
        <heim-card class="site">
          <header><h1>{{ $t('sites') }}</h1></header>
          <main>
            <div class="row" v-for="site in server.Sites" :site="site" :key="`site-${site.id}`">
              <div class="details-row">
                  <span><router-link :to="{ path: `/sites/${site.id}/details`}">{{site.name}} - {{site.url}}</router-link></span>
                  <span class="badge icon-link"><a :href="site.url" target="_blank"><heim-icon icon="open-in-new"></heim-icon></a></span>
              </div>
            </div>
          </main>
        </heim-card>
      </section>
      <section class="info">
        <heim-card class="stats">
          <header class="header">
            <h1>{{ $t('stats') }}</h1>
          </header>
          <main>
            <heim-line :chart-data="logs" :options="options"></heim-line>
          </main>
        </heim-card>
        <heim-card class="stats">
          <header><h1>{{ $t('specification') }}</h1></header>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('typeServer') }}</span>
                <span class="badge">{{ server.type_server ? server.type_server : $t('na') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('provider') }}</span>
                <span class="badge" v-if="server.Providers">
                  <router-link :to="{ path: `/providers/${server.Providers.id}` }">{{ server.Providers.name }}</router-link></span>
                <span class="badge" v-else>n/a</span>
              </div>
            </div>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('nbCPU') }}</span>
                <span class="badge"> {{ server.nb_cpu ? server.nb_cpu + $t('go') : $t('na') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('nbRAM') }}</span>
                <span class="badge">{{ server.nb_ram ? server.nb_ram + $t('go') : $t('na') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="details-row">
                <span>{{ $t('diskSpace') }}</span>
                <span class="badge">{{ server.disk_space ? server.disk_space + $t('go') : $t('na') }}</span>
              </div>
            </div>
        </heim-card>
        <heim-card class="stats">
          <header><h1>{{ $t('users') }}</h1></header>
          <main>
            <heim-user-card v-for="user in server.Users" :user="user" :key="`user-${user.id}`"></heim-user-card>
          </main>
        </heim-card>
      </section>
    </main>
  </section>
</template>

<script>
import HeimIcon from "@/components/icon/heim-icon";
import HeimCard from "@/components/layout/card/heim-card.vue";
import heimLine from "@/components/chart/heim-line.vue";
import HeimUserCard from "@/components/layout/card/heim-user-card.vue";
import { mapState } from "vuex";
import { dateFilter } from "vue-date-fns";

export default {
  name: "ServersDetails",
  components: {
    HeimIcon,
    HeimCard,
    heimLine,
    HeimUserCard
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          xAxes: [
            {
              type: "time",
              time: {
                // round: 'day'
                tooltipFormat: "ll HH:mm",
                unit: "hour"
              },
              scaleLabel: {
                display: true,
                labelString: "Time"
              }
            }
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "value"
              }
            }
          ]
        }
      }
    };
  },
  mounted() {
    const id = this.$route.params.id;
    this.$store.dispatch("getServer", id);
    this.$store.dispatch("getServerHealth", { id });

    this.$watch(
      vm => vm.server,
      val => {
        this.$store.dispatch("setTitle", `Server - ${val.name}`);
      }
    );
  },
  computed: {
    ...mapState({ server: state => state.serversState.server }),
    ...mapState({ serverHealth: state => state.serversState.serverHealth }),
    logs() {
      const logs = this.$store.getters.getServerHealth(
        `server-${this.server.id}`
      );
      if (!logs) return { label: [], datasets: [] };
      const filteredLog = logs.slice(Math.max(logs.length - 70, 1) - 1);
      const data = {
        labels: filteredLog.map(log => log.createdAt),
        datasets: [
          {
            label: "CPU usage",
            data: filteredLog.map(log => log.cpu_usage),
            borderColor: ["rgb(20, 141, 160)"],
            borderWidth: 1,
            fill: false
          },
          {
            label: "Memory usage",
            data: filteredLog.map(log => log.mem_usage),
            borderColor: ["rgb(233, 30, 99)"],
            borderWidth: 1,
            fill: false
          },
          {
            label: "Drive usage",
            data: filteredLog.map(log => log.drive_usage),
            borderColor: ["rgb(255, 165, 0)"],
            borderWidth: 1,
            fill: false
          }
        ]
      };
      return data;
    }
  },
  methods: {},
  filters: {
    date: dateFilter
  }
};
</script>

<style scoped>
.server-details,
.details-row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
}
.details-row {
  width: 100%;
}

.details-row .badge {
  background-color: var(--heim-grey-color);
}

.server-details > .paper-card,
.server-details > .info {
  width: 100%;
  margin-right: 0;
}

.server-details .stats,
.server-details .monitoring {
  margin-bottom: 1em;
}

.info {
  display: flex;
  flex-direction: column;
}

.disabled {
  color: #8b969c;
}

.monitoring,
.site {
  margin-bottom: 1em;
}

.link {
  padding: 1em;
  border-bottom: 1px solid #eee;
}

.link:last-child {
  border: none;
}

.info .paper-card {
  border-radius: 3px 3px 0 0;
}

.paper-card.monitoring {
  border-radius: 0;
}

.details-row span:first-child {
  padding: 0.2rem 0;
}

.icon-link .heim-icon {
  width: 16px;
  height: 16px;
}

/* Wide layout: when the viewport width is bigger than 768px, layout
changes to a wide layout. */
@media (min-width: 769px) {
  .server-details {
    flex-wrap: nowrap;
  }

  .server-details > .paper-card,
  .server-details > .info {
    width: 50%;
    margin-right: 1em;
    height: 100%;
  }
}
</style>
